// removed by extract-text-webpack-plugin
module.exports = {"morningstar-link-wrap":"morningstar-link-wrap___l1jrN center___2iqBf","morningstar-link-info":"morningstar-link-info___1xTSk h3___5u0xZ space-bottom-6___3i22S","morningstar-link-img":"morningstar-link-img___2s25z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MorningstarLink/MorningstarLink.css
// module id = 861
// module chunks = 0